import dayjs from 'dayjs'
import { replacePrepositionsWhitespaces } from '~shared/utils/replace-prepositions-whitespaces'
import { Clock2Icon } from '~shared/icons/clock2'
import Image from 'next/image'
import { cn } from '~shared/utils/cn'
import Link from 'next/link'
import { ComponentPropsWithoutRef } from 'react'
import { TJournal } from '~shared/api/getJournalsData/types'
import { getJournalPath } from '~shared/utils/getJournalPath'

export interface JournalCardProps extends ComponentPropsWithoutRef<'div'> {
  model: TJournal
}

export const JournalCard = (props: JournalCardProps) => {
  const { className, model, ...rest } = props
  if (!model) return null
  return (
    <div
      className={cn(
        'relative justify-between bg-secondary rounded-[24px] overflow-hidden group',
        className
      )}
      {...rest}>
      <Link
        href={getJournalPath(model?.tag?.slug, model?.slug)}
        prefetch={false}>
        <div className='relative rounded-[24px] overflow-hidden h-[203px] bg-tertiary'>
          <Image
            src={model?.image?.url || ''}
            alt='helo'
            fill
            className='object-cover scale-110 group-hover:scale-125 transition-transform duration-300'
          />
        </div>

        <div className='p-6 pt-0 flex flex-col pb-[67px]'>
          <span
            className='flex items-center justify-center mt-6 self-start text-[16px] leading-[1.2] px-[10px] h-[37px] text-white rounded-[24px]'
            style={{
              backgroundColor: model?.tag?.color || 'white'
            }}>
            {model?.tag?.name}
          </span>

          <p className='overflow-hidden mt-6 font-medium text-[16px] md:text-[20px] xl:text-[24px] tracking-[-0.01em] leading-[1] line-clamp-3'>
            {replacePrepositionsWhitespaces(model?.name ?? '')}
          </p>

          {/* <p className='mt-4 text-[16px] leading-[1.1] line-clamp-2'>
          Узнайте что-то новое для себя в самой свежей статье от MITM институт
        </p> */}
        </div>
        <div className='absolute left-6 bottom-6 flex gap-6 mt-auto text-[14px] md:text-[16px] leading-[1.2] text-[#6A6A6A]'>
          <p>{dayjs(model.createdDate).format('DD.MM.YYYY')}</p>
          <div className='whitespace-nowrap flex items-center gap-[4px]'>
            <Clock2Icon />
            {`${Number(model.time?.split(':')[1] || 5)} мин.`}
          </div>
        </div>
      </Link>
    </div>
  )
}
